import { assertNever } from "../../../types/index.ts";

export const P0_MANAGEMENT_ROLE_BASE_NAME = "P0 Service Management";
export const P0_SSH_ROLE_BASE_NAME = "P0 Virtual Machine Management";
export const P0_SSH_SUDO_ROLE_BASE_NAME = "P0 Virtual Machine Admin Management";
export const P0_BASTION_HOST_ROLE_BASE_NAME = "P0 Bastion Host Management";
export const P0_ASSESSMENT_ROLE_BASE_NAME = "P0 Security Assessment";

export const toP0ManagementRoleName = (
  baseName: string,
  subscriptionId: string
) => {
  return `${baseName} - ${subscriptionId}`;
};

export const P0_MANAGEMENT_ROLE_PERMISSIONS = [
  "Microsoft.Resources/subscriptions/resources/read",
  "Microsoft.Authorization/roleDefinitions/read",
  "Microsoft.Authorization/roleAssignments/write",
  "Microsoft.Authorization/roleAssignments/delete",
  "Microsoft.Authorization/roleAssignments/read",
  "Microsoft.Resources/subscriptions/resourceGroups/read",
  "Microsoft.Resources/subscriptions/resourceGroups/resources/read",
];

export const P0_ASSESSMENT_ROLE_PERMISSIONS = [
  //TODO: Actually see which permissions are needed
  //Currently just gave the reader role to the application
  "Microsoft.Authorization/roleAssignments/read",
  "Microsoft.Authorization/roleDefinitions/read",
  "Microsoft.Resources/subscriptions/resources/read",
  "Microsoft.Resources/subscriptions/resourceGroups/resources/read",
];

export const P0_BASTION_HOST_ROLE_PERMISSIONS = [
  "Microsoft.Network/bastionHosts/read",
  "Microsoft.Network/bastionHosts/disconnectActiveSessions/action",
];

export const P0_SSH_ROLE_PERMISSIONS = [
  "Microsoft.Compute/virtualMachines/read",
  "Microsoft.Compute/virtualMachines/extensions/read",
  "Microsoft.Network/bastionHosts/getactivesessions/action",
  "Microsoft.Network/networkInterfaces/read",
  "Microsoft.Network/publicIPAddresses/read",
  "Microsoft.Network/virtualNetworks/peer/action",
  "Microsoft.Network/virtualNetworks/virtualNetworkPeerings/delete",
  "Microsoft.Network/virtualNetworks/virtualNetworkPeerings/read",
  "Microsoft.Network/virtualNetworks/virtualNetworkPeerings/write",
];

export type P0RoleBaseName =
  | typeof P0_ASSESSMENT_ROLE_BASE_NAME
  | typeof P0_BASTION_HOST_ROLE_BASE_NAME
  | typeof P0_MANAGEMENT_ROLE_BASE_NAME
  | typeof P0_SSH_ROLE_BASE_NAME
  | typeof P0_SSH_SUDO_ROLE_BASE_NAME;

export const toPermissions = (baseName: P0RoleBaseName): string[] => {
  switch (baseName) {
    case P0_MANAGEMENT_ROLE_BASE_NAME:
      return P0_MANAGEMENT_ROLE_PERMISSIONS;
    case P0_SSH_ROLE_BASE_NAME:
    case P0_SSH_SUDO_ROLE_BASE_NAME:
      return P0_SSH_ROLE_PERMISSIONS;
    case P0_BASTION_HOST_ROLE_BASE_NAME:
      return P0_BASTION_HOST_ROLE_PERMISSIONS;
    case P0_ASSESSMENT_ROLE_BASE_NAME:
      return P0_ASSESSMENT_ROLE_PERMISSIONS;
    default:
      assertNever(baseName);
      return [];
  }
};

export const toP0ManagementRoleCondition = (
  servicePrincipalId: string
): string => {
  return `(
 (
  NOT(ActionMatches{'Microsoft.Authorization/roleAssignments/write'})
 )
 OR
 (
  @Request[Microsoft.Authorization/roleAssignments:PrincipalId] GuidNotEquals ${servicePrincipalId}
 )
)
AND
(
 (
  NOT(ActionMatches{'Microsoft.Authorization/roleAssignments/delete'})
 )
 OR
 (
  @Resource[Microsoft.Authorization/roleAssignments:PrincipalId] GuidNotEquals ${servicePrincipalId}
 )
)`;
};
